export const root = '/email';

const paths = {
  root,
  list: '/email/:module',
  detail: '/email/:module/:id',
};

export default paths;
